import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class FileUploaderDataService {
  private cashVoucherBasePath: string = `${environment.url}/api/CashVouchers`;
  private externalVoucherBasePath: string = `${environment.url}/api/ExternalVouchers`;

  constructor(
    private http: HttpClient
  ) {

  }

  //#region CRM > Vouchers > Cash Vouchers

  uploadCashVoucherExcel(File: any) {
    return this.http.post(`${this.cashVoucherBasePath}/UploadCashVoucherExcel`, File);
  }

  //#endregion

  //#region CRM > Vouchers > Cash Vouchers

  uploadExternalVoucherExcel(File: any, PartnerId: any) {
    return this.http.post(`${this.externalVoucherBasePath}/UploadExternalVoucherExcel`, File, {
    params: { partnerId: PartnerId }
  });
  }

  //#endregion
}
